/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components'

import { CarouselEl } from '../../../../components/carousel/elements'
import { accent, background2 } from '../../../../styles/colors'
import { center, hCenter, hFlex, vFlex } from '../../../../styles/style-helpers'

export const PricingEl = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  .intro {
    padding: 0 1em;

    p {
      line-height: 1.5;
      color: #e7e7e7;
      margin-bottom: 1.5em;

      &.highlighted {
        color: #fff;
      }
    }
  }

  .invites {
    width: 100%;
    padding: 1em;

    .card {
      padding: 1em;
      background: ${background2};
      border-radius: 0.25em;
      ${vFlex};
      align-items: flex-end;

      h5 {
        width: 100%;
        margin-bottom: 1em;
      }

      p {
        width: 100%;
        margin-bottom: 1em;
        line-height: 1.5;
        color: #c7c7c7;

        span {
          color: ${accent};
        }
      }

      button {
        font-size: 0.9em;
      }
    }
  }

  #plans {
    position: relative;
    width: 100%;
    margin: 2.5em 0 5em;
    padding: 0 0 0 1em;
    ${hFlex};
    align-items: unset;

    .features {
      flex: 1;
      background: ${background2};
      border-radius: 0.5em;
      margin-right: 0.5em;
    }

    ${CarouselEl} {
      flex: 1;
    }

    .plan {
      display: block;
      width: calc(30vw + 1em);
      ${hFlex};
      padding: 0 0.5em;

      .content {
        background: ${background2};
        height: 100%;
        width: 100%;
        border-radius: 0.5em;

        .header {
          p {
            margin-top: 0.5em;
            color: ${accent};
          }
        }

        .footer {
          ${vFlex};
          font-size: 0.8em;
        }
      }

      .row {
        text-align: center;
      }
    }

    .header {
      height: 7.5em;
      width: 100%;
      ${vFlex};
      padding: 0 1em;
    }

    .row {
      height: 5em;
      width: 100%;
      margin: 0.25em 0;
      padding: 1em;

      p {
        line-height: 1.5;
      }
    }

    .footer {
      width: 100%;
      padding-bottom: 2em;
    }
  }

  .contact {
    margin: 5em 0;
    ${vFlex};

    p {
      span {
        color: ${accent};
        text-decoration: underline;
      }
    }
  }
`

export const MonthlyToggleEl = styled.div`
  ${hFlex};
  padding: 0 1em;
  margin-top: 3.5em;

  .MuiButtonGroup-contained {
    width: 100%;

    button {
      background: #333;
      width: 50%;

      span {
        color: #777;
      }

      ${({ showMonthly }) =>
        !showMonthly
          ? css`
              &:first-of-type {
                background: #e7e7e7;

                span {
                  color: #000;
                }
              }
            `
          : css`
              &:last-of-type {
                background: #e7e7e7;

                span {
                  color: #000;
                }
              }
            `}
    }
  }

  .item {
    ${hFlex};
    padding: 0.5em 1em;
    background: #e7e7e7;
    cursor: pointer;

    &:first-of-type {
      border-top-left-radius: 0.5em;
      border-bottom-left-radius: 0.5em;
    }

    &:last-of-type {
      border-top-right-radius: 0.5em;
      border-bottom-right-radius: 0.5em;
    }

    > * {
      pointer-events: none;
      user-select: none;
    }

    &.active {
      background: #333;
      cursor: auto;

      h5 {
        color: white;
      }
    }
  }
`

export const InviteOthersEl = styled.div`
  width: 90%;
  height: 66%;
  ${center};
  background: ${background2};
  border-radius: 1em;
  padding: 1em 1em 2em;
  overflow: auto;

  .close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.75em;
    z-index: 1;
  }

  > h4 {
    font-weight: bold;
    margin: 0.5em 0 1em;
  }

  > p {
    margin-bottom: 1em;
    line-height: 1.3;
  }

  .sent-invite {
    width: 100%;
    ${hFlex};
    justify-content: space-between;
  }

  .form {
    position: relative;
    width: 100%;
    margin-top: 2em;
    padding-top: 2em;

    &:before {
      content: '';
      ${hCenter};
      top: 0;
      width: 50%;
      height: 1px;
      background: radial-gradient(#999, transparent);
    }

    form {
      width: 100%;
      ${vFlex};
      align-items: flex-end;

      button {
        font-size: 0.9em;
        margin-top: 0.5em;
      }
    }
  }
`
